// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"bbda07a9","1819":"bbda07a9","2090":"1ced47c9","2250":"bbda07a9","5067":"22c58ca1","6575":"1ced47c9","7159":"1ced47c9","8255":"149b6771","9588":"1ced47c9","9854":"bbda07a9"}[chunkId] + ".chunk.css";
};